import {
  GroupUserIcon
} from "./chunk-6IKZYBF4.mjs";
export {
  GroupUserIcon
};
